import { styled } from "@mui/material";

interface ChartTitleStyledProps {
  isSuspended?: boolean;
}

const ChartTitleStyled = styled("div")<ChartTitleStyledProps>(({ theme, isSuspended }) => ({
  fontSize: "20px",
  paddingLeft: "75px",
  color: isSuspended ? theme.palette.text20.main : theme.palette.text50.main,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));

const StyledTooltip = styled("div")(({ theme }) => ({
  zIndex: 100,
  padding: "5px 10px",
  display: "block",
  fontSize: "12px",
  color: theme.palette.text30.main,
  backgroundColor: theme.palette.surfaceLight10.main,
  border: `2px solid ${theme.palette.surfaceLight40.main}`,
  alignItems: "center",
  minWidth: "150px",
  borderRadius: "5px",
  boxShadow: "rgba(0, 0, 0, 0.3) 0 2px 10px",
  boxSizing: "border-box",
}));

export { ChartTitleStyled, StyledTooltip };
